import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { push } from 'react-router-redux'

// External
import {
    Table, TableCell, TableHeader, TableLoading,
    Button,
    RoundedTabs, Modal, Pagination,
    Select, TextInput
} from 'advenio-components'
import { Form } from 'formsy-react'

// Custom
import {Container, TableContainer, HeaderContainer, Toolbar, Counter, ShowOnly, CellCheckContainer, TableActions, ModalContainer} from './video-styled'
import {generatorColumns, tabs} from './contants'
import {CheckBtn, Dropdown, Toaster as Toast} from './components'
import {
    getCenters as getCentersService,
    getStudents as getStudentsService,
    getClassrooms as getClassroomsService,
    createCenterVideos as createCenterVideosService,
} from './video-generator.service'
import DetailVideos from './DetailVideos'

class VideoGenerator extends Component {

    constructor(props) {
        super(props)

        this.state = {
            isOpened: false,
            students: [],
            classrooms: [],
            selectedStudents: [],
            checkAll: false,
            centers: [],
            centerId: null,
            isLoaded: false,
            pageSelected: 1,
            elementsPerPage: 15,
            totalElements: 0,
            classroomId: 0,
            isActive: false,
            error: false
        }
    }

    componentDidMount() {
        getCentersService().then(
            (result) => {
                this.setState({
                    centers: result
                });
            },
            (error) => this.activateToaster('Ha ocurrido un error', true)
        )
    }

    activateToaster = (msg, error = false, goTo = false) =>{
        const to = {
            currentTarget: {
                id: '/videos'
            }
        };
        this.setState({ error: error, isActive: true, msg: msg }, () => {
            setTimeout(() => {
                this.setState({ isActive: false, error: false });
                if(goTo){
                    this.goTo(to)
                }
            }, 3000);
        });
    }

    goTo = (e) => this.props.goTo(e.currentTarget.id);

    getStudents = (centerId, page, classroomId = 0) => {
        this.setState({isLoaded: true});
        getStudentsService(centerId, page, classroomId).then(
            (result) => {
                const students = result.data;
                const pagination = result.meta;
                students.map(student => {
                    student.fullName = `${student.first_name} ${student.last_name_paternal} ${student.last_name_maternal}`;
                    return student;
                });

                this.setState(prevState =>{
                    return{
                        ...prevState,
                        isLoaded: false,
                        students: students,
                        totalElements: pagination.total,
                        checkAll : students.map(it => it.id).every(i => prevState.selectedStudents.map(it => it.id).includes(i)),
                    }
                });
            },
            (error) => this.activateToaster('Ha ocurrido un error', true)
        )
    }

    getClassrooms = (centerId) => {
        this.setState({isLoaded: true})
        getClassroomsService(centerId).then(
            (result) => {
                this.setState({classrooms: result})
            },
            (error) => this.activateToaster('Ha ocurrido un error', true)
        )
    }

    handleSelectClassroom = classroomId => {
        this.setState({
            students: [],
            selectedStudents: [],
            checkAll: false,
            pageSelected: 1,
            elementsPerPage: 15,
            totalElements: 0,
            classroomId: classroomId || 0
        })
        this.getStudents(this.state.centerId, 1, classroomId);
    }

    handleSelectCenter = event => {
        const centerId = event.target.value;

        this.setState({
            students: [],
            classrooms: [],
            selectedStudents: [],
            pageSelected: 1,
            elementsPerPage: 15,
            totalElements: 0,
            centerId: centerId
        })

        this.getClassrooms(centerId);
        this.getStudents(centerId, 1);
    }

    handleCheck = row => () => {
        if(row){
            this.setState(prevState =>{
                const newSelectedStudents = [...prevState.selectedStudents];
                const index = newSelectedStudents.findIndex(it => it.id === row.id);

                if(index < 0){ //no existe
                    newSelectedStudents.push(row);
                }else{
                    newSelectedStudents.splice(index, 1);
                }

                return{
                    ...prevState,
                    checkAll : prevState.students.map(it => it.id).every(i => newSelectedStudents.map(it => it.id).includes(i)),
                    selectedStudents: newSelectedStudents
                }
            });
        }else{
            this.setState(prevState =>{
                const checkAll = !prevState.checkAll;
                const students = prevState.students.map(student => student.id);
                const removedStudents = prevState.selectedStudents.filter(it => !students.includes(it.id));

                return{
                     ...prevState,
                    checkAll : checkAll,
                    selectedStudents: checkAll
                        ? removedStudents.concat(prevState.students)
                        : removedStudents
                }
            });
        }
    }

    onClickPage = page => {
        this.setState({
            pageSelected: page,
            checkAll: false
        });
        this.getStudents(this.state.centerId, page, this.state.classroomId);
    }

    handleClickModal = () => {
        this.setState(prevState => prevState.isOpened = !prevState.isOpened)
    }

    handleSubmit = input => {
        const body = {
            description: input.desc,
            students: this.state.selectedStudents
        }
        this.setState({isOpened: false, isLoaded: true});

        createCenterVideosService(this.state.centerId, body).then(
            (response) => {
                this.activateToaster(response.message, false, true)
            },
            (error) => this.activateToaster('Ha ocurrido un error', true)
        )
    }

    render() {

      return (
        <Container>
            <TableContainer>
                <HeaderContainer>
                    <RoundedTabs
                        selectedTab="/video-generator"
                        tabs={tabs}
                        onClick={this.goTo}
                    />
                </HeaderContainer>
                <Toolbar>
                    <Form>
                        <Select
                            disabled={this.state.isLoaded}
                            name="center"
                            label="Centro"
                            required
                            onChangeCallback={this.handleSelectCenter}
                            value="-1"
                            placeholder="Seleccione..."
                            withGroup
                            optionsWithGroup={this.state.centers}
                            options={[]}
                            className="select-component"
                        />
                    </Form>
                    <Counter>Alumnos seleccionados {this.state.selectedStudents.length} / {this.state.totalElements}</Counter>
                    <ShowOnly>
                        <Dropdown options={this.state.classrooms} onClick={this.handleSelectClassroom} disabled={this.state.isLoaded}/>
                    </ShowOnly>
                </Toolbar>

                {this.state.isLoaded ?
                    <TableLoading
                        roundedCorners
                        columns={generatorColumns}
                        rows={10}
                    />
                :
                    <Table
                        data={this.state.students}
                        columns={[
                            {
                                id: 1,
                                sortable: false,
                                Header: () => <CellCheckContainer>
                                        <CheckBtn
                                            key={Number(0)}
                                            id={Number(0)}
                                            onCheck={this.handleCheck(Number(0))}
                                            checked={this.state.checkAll}
                                            disabled={!this.state.students.length}
                                        />
                                </CellCheckContainer> ,
                                accessor: ({ id, fullName, classroom_name}) => ({id, fullName, classroom_name}),
                                Cell: ({ value }) => <TableCell center style={{paddingBottom: 0, lineHeight: 'normal'}}>
                                    <CheckBtn
                                        key={value.id}
                                        id={value.id}
                                        onCheck={this.handleCheck(value)}
                                        checked={this.state.selectedStudents.some(it => it.id === value.id)}
                                    />
                                </TableCell>,
                                maxWidth: 50,
                            },
                            {
                                id: 2,
                                sortable: false,
                                Header: () => <TableHeader title="Nombre" center blue />,
                                accessor: 'fullName',
                                Cell: ({ value }) => <TableCell center style={{paddingBottom: 0, lineHeight: 'normal'}}>{value}</TableCell>,
                            },
                            {
                                id: 3,
                                sortable: false,
                                Header: () => <TableHeader title="Sala" center blue />,
                                accessor: 'classroom_name',
                                Cell: ({ value }) => <TableCell center style={{paddingBottom: 0, lineHeight: 'normal'}}>{value}</TableCell>,
                            },
                            {
                                id: 4,
                                sortable: false,
                                Header: () => <TableHeader title="Programa" center blue />,
                                accessor: 'study_programs_name',
                                Cell: ({ value }) => <TableCell center style={{paddingBottom: 0, lineHeight: 'normal'}}>{value}</TableCell>,
                            },
                        ]}
                    />
                }

                <TableActions>
                    <Pagination
                        totalElements={this.state.totalElements}
                        elementsPerPage={this.state.elementsPerPage}
                        onPageClick={this.onClickPage}
                        pageSelected={this.state.pageSelected}
                    />
                    <Button primary small onClick={this.handleClickModal} disabled={this.state.isLoaded || !this.state.selectedStudents.length}>
                        <span>Generar</span>
                    </Button>
                </TableActions>

            </TableContainer>
            <Modal
                isOpened={this.state.isOpened}
                onClose={this.handleClickModal}
                headerTitle="Detalle"
            >
                <ModalContainer>
                    <Form onSubmit={this.handleSubmit}>
                        <TextInput
                            required
                            name="desc"
                            label="Descripción"
                        />

                        <DetailVideos data={this.state.selectedStudents} maxHeight={600}/>

                        <Button success small type="submit" style={{margin: '30px 0 0'}}>Generar</Button>
                    </Form>
                </ModalContainer>
            </Modal>
            <Toast isActive={this.state.isActive} msg={this.state.msg} error={this.state.error}/>
        </Container>
      );
    }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
    goTo: path => dispatch(push(path)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VideoGenerator))

                {/* <Generator /> */}
                {/* <TabPanel active={this.state.activeTab === "videos"}>
                    {this.state.activeTab === "videos" && <VideoList />}
                </TabPanel>
                <TabPanel active={this.state.activeTab === "generar"}>
                    {this.state.activeTab === "generar" && <Generator />}
                </TabPanel> */}



// WEBPACK FOOTER //
// ./src/Containers/VideoGenerator/VideoGenerator.jsx